import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { InlineNotification, ModalDialog, useLocalizeMessage } from 'libs.nucleus';
export const ValidationErrorModal = ({ selectedSites, invalidSites, errorMessage, onClose, onDeleteValidSites, isDeleting, }) => {
    const translate = useLocalizeMessage();
    const validSitesCount = useMemo(() => {
        return selectedSites.filter((site) => !invalidSites.some((invalidSite) => invalidSite.id === site.id)).length;
    }, [selectedSites, invalidSites]);
    // Memoized sites list to avoid duplication
    const sitesListElement = useMemo(() => (_jsx("div", { className: 'flex flex-col gap-2 max-h-40 overflow-y-auto', children: invalidSites.map((site) => (_jsx(InlineNotification, { title: site.name, type: 'info' }, site.id))) })), [invalidSites]);
    // Consolidated modal configuration based on whether any sites can be deleted
    const modalConfig = useMemo(() => {
        const canDeleteSome = validSitesCount > 0;
        const actionButtons = canDeleteSome
            ? [
                {
                    label: translate('Cancel'),
                    onClick: onClose,
                },
                {
                    label: translate('Delete {count} sites', { count: validSitesCount }),
                    onClick: onDeleteValidSites,
                    isDestructive: true,
                    disabled: isDeleting,
                },
            ]
            : [
                {
                    label: translate('Close'),
                    onClick: onClose,
                },
            ];
        return {
            title: canDeleteSome ? translate('Some sites cannot be deleted') : translate('Cannot delete selected sites'),
            body: canDeleteSome ? (_jsxs("div", { className: 'flex flex-col gap-4', children: [_jsx("p", { className: 'text-sm text-gray-700', children: translate('{count} of {total} selected sites cannot be deleted:', {
                            count: invalidSites.length,
                            total: selectedSites.length,
                        }) }), _jsx("p", { className: 'text-sm text-gray-600 italic', children: translate(errorMessage) }), sitesListElement, _jsx("p", { className: 'text-sm text-gray-700', children: translate('Delete the remaining {count} sites anyway?', {
                            count: validSitesCount,
                        }) })] })) : (_jsxs("div", { className: 'flex flex-col gap-4', children: [_jsx("p", { className: 'text-sm text-gray-700', children: translate(errorMessage) }), sitesListElement] })),
            actionButtons,
        };
    }, [
        validSitesCount,
        sitesListElement,
        selectedSites,
        invalidSites,
        errorMessage,
        translate,
        onClose,
        onDeleteValidSites,
        isDeleting,
    ]);
    return (_jsx(ModalDialog, { isOpen: true, closeDialog: onClose, title: modalConfig.title, body: modalConfig.body, actionButtons: modalConfig.actionButtons }));
};
